let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("685rk")).then(() => parcelRequire('3knLh'));